import React from 'react';
import { CartesianGrid, Line, LineChart, ResponsiveContainer, XAxis, YAxis, Tooltip } from 'recharts';
import { getMonthShortName } from 'utility/monthNames';

import * as Styled from './Chart.styles';

export const Chart = ({ chartData }) => {
  const colors = {
    axis: '#7B809A',
  };

  let data = [];

  if (chartData !== undefined) {
    chartData.legend.map((item) => {
      colors[item.name] = item.colour;
    });

    chartData.dataPoints.map((item) => {
      const { month, ...rest } = item;
      data.push({
        name: getMonthShortName(month),
        ...rest,
      });
    });
  }

  const getUserFriendlyName = (name) => {
    switch (name) {
      case 'revenue':
        return 'Przychody';
      case 'cost':
        return 'Koszty';
      default:
        return name;
    }
  };

  return (
    <Styled.Wrapper>
      <Styled.Title>Przychody / Koszty</Styled.Title>
      <Styled.Legend>
        {chartData !== undefined &&
          chartData.legend.map((item) => {
            return (
              <div className="item" key={item.name}>
                <div className="mark" style={{ background: item.colour }} />
                {getUserFriendlyName(item.name)}
              </div>
            );
          })}
      </Styled.Legend>

      <Styled.ChartWrapper>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            width={500}
            height={300}
            data={data}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="5 5" />
            <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fill: colors.axis, fontSize: 12 }} />
            <YAxis axisLine={false} tickLine={false} tick={{ fill: colors.axis, fontSize: 12 }} />
            <Tooltip itemStyle={{ fontSize: 14, padding: 0 }} labelStyle={{ fontSize: 16 }} />
            {chartData !== undefined &&
              chartData.legend.map((item) => {
                return (
                  <Line
                    key={item.name}
                    type="linear"
                    dataKey={item.name}
                    stroke={item.colour}
                    name={getUserFriendlyName(item.name)}
                    strokeWidth={3}
                    dot={{ r: 5, fill: item.colour }}
                    activeDot={{ r: 5, fill: item.colour, stroke: item.colour }}
                  />
                );
              })}
          </LineChart>
        </ResponsiveContainer>
      </Styled.ChartWrapper>
    </Styled.Wrapper>
  );
};
